var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "status_1_content_Indexes",
      class: { showClass: _vm.showStatus }
    },
    [
      _c("div", { staticClass: "header" }, [_vm._v("\n    步 骤\n  ")]),
      _vm._v(" "),
      _c(
        "ul",
        [
          _vm._l(_vm.currentValue, function(item, index) {
            return _c(
              "li",
              {
                key: index,
                class: _vm.activeIndex == index ? "active" : "",
                attrs: { title: item.extendOption.indexText },
                on: {
                  click: function($event) {
                    return _vm.liClick(item, index)
                  }
                }
              },
              [
                _vm._v(
                  "\n      " + _vm._s(item.extendOption.indexText) + "\n    "
                )
              ]
            )
          }),
          _vm._v(" "),
          _c("div", { ref: "line", staticClass: "line" })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06a5c0ad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06a5c0ad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/new_learning_module/components/status_1_content_Indexes.vue
// module id = null
// module chunks = 